module.exports = __webpack_public_path__ + "img/j-logo-full.b2775fd0.svg";